var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 346",
    x: 0.834961,
    y: 9.79126,
    width: 20,
    height: 1,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 347",
    x: 11.335,
    y: 0.29126,
    width: 20,
    height: 1,
    transform: "rotate(90 11.335 0.29126)",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.fbe30935212263c04eee52914d804efc.svg";
export { ForwardRef as ReactComponent };